import { styled } from '@mui/system';
import { PauseCircleOutline } from '@mui/icons-material';
import { theme } from '../../lib/index';

export const StyledPauseButton = styled(PauseCircleOutline, {})({
  opacity: 1,
  width: 28,
  height: 28,

  color: theme.palette.fontgrey,

  transition: 'opacity 250ms ease-in-out',

  '&:hover': {
    opacity: 0.8,

    transition: 'opacity 250ms ease-in-out',
  },
});
